import { useEffect, useState } from "react";

type Props = {
  maxLength: number;
  text: string;
  className?: string;
};

export default function TextCounter({ text, maxLength, className = "" }: Props) {

  const [warningStart, setWarningStart] = useState<number>(500);
  const [remaining, setRemaining] = useState<number>(0);

  useEffect(() => {

    if(text && maxLength) {
      setWarningStart(Math.ceil(maxLength * 0.3));
      setRemaining(maxLength- text.length);
    }
  } ,[maxLength, text])

  return <>
    {
      text && 
      <div className={className + " text-sm ml-2 " + (remaining <= warningStart ? "text-danger": "text-muted")}>Remaining Characters: {remaining < 0 ? 0 : remaining}</div>
    }
  </>;
}
